<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex justify-center items-center z-50"
      aria-modal="true"
      role="dialog"
    >
      <div
        class="bg-white w-[320px] md:w-[420px] rounded-3xl p-6 shadow-xl transition-all"
      >
        <div class="p-2 flex flex-col items-center">
          <!-- Icon -->
          <div
            class="w-20 h-20 flex items-center justify-center rounded-full bg-red-600 animate-pulse shadow-lg ring-4 ring-red-200"
          >
            <icon name="questionmark" class="w-10 h-10 text-white" />
          </div>

          <!-- Title -->
          <h1 class="text-lg md:text-xl font-semibold mt-4 text-gray-800">
            Sign Out Confirmation
          </h1>
          <p class="text-sm md:text-base text-center text-gray-600 mt-2 px-4">
            Are you sure you want to sign out of the gateway?
          </p>

          <!-- Divider -->
          <div class="w-full h-px bg-gray-200 my-4"></div>

          <!-- Buttons -->
          <div class="flex gap-3 mt-2">
            <button
              @click="closeModal"
              class="px-4 py-2 text-sm md:text-base rounded-lg border border-gray-800 hover:text-white text-gray-800 hover:bg-gray-800 transition hover:shadow"
            >
              Stay Logged In
            </button>
            <button
              @click="toggleSignout"
              class="px-4 py-2 text-sm md:text-base bg-red-600 text-white rounded-lg hover:bg-red-700 transition hover:shadow"
            >
              Yes, Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import icon from "../icon.vue";

export default {
  name: "SignoutConfirmationPage",
  components: {
    icon,
  },
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
      this.$emit("close");
    },
    toggleSignout() {
      this.$store.dispatch("setUser", null);
      localStorage.removeItem("token");
      localStorage.removeItem("vuex");
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
